module.exports = __webpack_public_path__ + "img/transmision-17.c01fe353.jpg";